import { SvgIcon } from "@material-ui/core";
import React from "react";

const MinusIcon = props => (
  <SvgIcon {...props}>
    <g id="Icon/MinusIcon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox={props.viewBox}
      >
        <path
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d="M12.949 3.047a6.996 6.996 0 010 9.898 6.996 6.996 0 01-9.898 0 6.996 6.996 0 010-9.898c2.73-2.73 7.163-2.73 9.898 0zM4.732 7.999h6.533"
        />
      </svg>
    </g>
  </SvgIcon>
);

export default MinusIcon;



// WEBPACK FOOTER //
// ./src/icons/MinusIcon.jsx